import {LeaderboardConstants} from '../../../../shared/leaderboard_data/LeaderboardConstants'
import {LeaderboardStickyRowData} from '../../../../shared/leaderboard_data/LeaderboardInterfaces'
import {UILeaderboardBaseTableRowView} from '../../../shared/scripts/ui_leaderboard/UILeaderboardBaseTableRowView'
import {UILeaderboardTableRowViewRanked} from '../../../shared/scripts/ui_leaderboard/UILeaderboardTableRowViewRanked'
import {UILeaderboardTableRowViewUnranked} from '../../../shared/scripts/ui_leaderboard/UILeaderboardTableRowViewUnranked'

export class UIWLeaderboardStickyRowController {
    readonly stickyRowDiv: HTMLTableElement
    readonly stickyRowContainer: HTMLDivElement
    readonly rankingTableDiv: HTMLTableElement

    protected stickyTableRowView: UILeaderboardBaseTableRowView | undefined
    private myTableRowIndex: number = -1
    private searchValue: string = ''

    constructor() {
        this.stickyRowDiv = document.getElementById('leaderboard_sticky_row') as HTMLTableElement
        this.stickyRowContainer = document.getElementById('leaderboard_sticky_table_container') as HTMLDivElement
        this.rankingTableDiv = document.getElementById('leaderboard_ranking_table') as HTMLTableElement
    }

    updateStickyRowData(rowData: LeaderboardStickyRowData, gridHeightPx: number) {
        const isEmptyRank = rowData.rank == LeaderboardConstants.emptyRank
        this.myTableRowIndex = isEmptyRank ? Infinity : rowData.rank as number - 1
        this.clearStickyRowData()
        rowData.unrankedOverrideMessage == undefined ? this.createStickyTableRowViewRanked(rowData) : this.createStickyTableRowViewUnranked(rowData)
        this.stickyRowContainer.style.marginBottom = `-${this.stickyRowContainer.clientHeight}px`
        this.updateStickyRowStyle(gridHeightPx, 0)
    }

    createStickyTableRowViewUnranked(rowData: LeaderboardStickyRowData) {
        const stickyRowIndex = 0
        this.stickyTableRowView = new UILeaderboardTableRowViewUnranked(this.stickyRowDiv, rowData, stickyRowIndex, (leaderboardUrl: string) => undefined)
    }

    createStickyTableRowViewRanked(rowData: LeaderboardStickyRowData) {
        const stickyRowIndex = 0
        this.stickyTableRowView = new UILeaderboardTableRowViewRanked(this.stickyRowDiv, rowData, stickyRowIndex, (leaderboardUrl: string) => undefined)
    }

    clearStickyRowData() {
        this.stickyTableRowView = undefined
        this.stickyRowDiv.replaceChildren()
        this.stickyRowContainer.style.marginBottom = '0'
    }

    updateStickyRowStyle(gridHeightPx: number, scrollPositionPx: number, newMyTableRowIndex?: number) {
        if(newMyTableRowIndex != undefined) this.myTableRowIndex = newMyTableRowIndex
        if(this.stickyRowDiv == null) return
        const rowHeight: number = this.stickyRowDiv.clientHeight + 4
        const screenTop: number = scrollPositionPx
        const screenBottom: number = scrollPositionPx + gridHeightPx
        const playerPos: number = this.myTableRowIndex * rowHeight + rowHeight

        const isUnranked: boolean = this.myTableRowIndex >= 0 == false
        const stickyRowAtTop: boolean = isUnranked ? false : (playerPos < screenBottom - rowHeight)
        let stickyRowVisible: boolean = ((playerPos > screenBottom) || (playerPos < screenTop + rowHeight))

        if(this.myTableRowIndex == -1) stickyRowVisible = false

        this.stickyRowContainer.style.opacity = stickyRowVisible ? '1' : '0'

        /* 1px offset fix due to Chrome bug on position sticky:
            https://bugs.chromium.org/p/chromium/issues/detail?id=810352
         */
        const pixelOffset = 1
        this.stickyRowContainer.style.top = stickyRowAtTop ? `-${pixelOffset}px` : gridHeightPx - this.stickyRowContainer.clientHeight + pixelOffset + 'px'
        this.stickyRowContainer.style.pointerEvents = stickyRowVisible ? 'auto' : 'none'
    }

    setSearchValue(searchValue: string) {
        this.searchValue = searchValue
        this.myTableRowIndex = -1
    }

    tableRowLoadingCompleted() {
        if(this.searchValue != '') this.myTableRowIndex = this.findMyTableRowIndexFromHTML()
    }

    private findMyTableRowIndexFromHTML(): number {
        for(let i = 0;i < this.rankingTableDiv.children.length;i++) {
            const tableRowElement = this.rankingTableDiv.children[i] as HTMLTableRowElement
            if(tableRowElement.children[0].className == 'my_leaderboard_cell') return i
        }
        return -1
    }
}
